import styled from 'styled-components';
import Text from '@text';
import themedColor from '../../../styles/theme/themed-color';
import styleUtils from '../../../styles/style.utils';
import themedFontSize from '../../../styles/theme/themed-font-size';

const BackgroundContainer = styled.div`
  background: ${themedColor('HEADER_BG')};
  padding: ${styleUtils.px(48)} 0;
  display: flex;
  justify-content: center;
  flex: 1 0 auto;
`;

const Container = styled.div`
  max-width: ${styleUtils.size('MAX_CONTAINER_WIDTH')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Button = styled.div`
  background: ${themedColor('BUTTON_BG')};
  color: ${themedColor('BUTTON_TEXT')};
  border: 1px solid ${themedColor('BUTTON_BORDER')};
  height: ${styleUtils.px(50)};
  padding: 0 ${styleUtils.px(32)};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${styleUtils.px(25)};
  cursor: pointer;

  p {
    margin: 0;
    color: ${themedColor('BUTTON_TEXT')};
    font-size: ${themedFontSize('HEADER_TITLE_M')};
  }
`;

const Header = styled(Text)`
  &.ucf-paragraph {
    font-size: ${themedFontSize('BODY')};
    margin-bottom: ${styleUtils.px(24)};
    color: ${themedColor('TEXT_BLUE')};
    font-weight: 600;
  }
`;

const ShowFormComponents = { Header, Button, Container, BackgroundContainer };

export default ShowFormComponents;
